import React from "react";

import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../components/pageList";

import { useCellRender } from "../hooks/useCellRender";
import { useFormatter } from "../hooks/useFomatter";

import ActionCellRender from "../components/actionCellRender";

import { IconTrash, IconPencil, IconSettings } from "@tabler/icons";
import { NumberInput, TextInput, Select, Text, Textarea } from "@mantine/core";

import _ from "lodash";
import moment from "moment";
import { DatePicker } from "@mantine/dates";
import { DATA_INCENTIVE_TYPE } from "../data/options";
import { Card, Group } from "@mantine/core";
import OrderList from "../components/orderList";
import { useForceUpdate } from "@mantine/hooks";
import ReactJson from "react-json-view";
import WorkflowDiagram from "../components/workflow/workflowDiagram";
import WorkflowTester from "../components/workflow/workflowTester";
import WorkflowCredentials from "../components/workflow/workflowCredentials";

const AIWorkflow = () => {
  const apiEntity = "aiWorkFlow";
  const initialValues = {
    id: "",
    title: "",
    description: "",
    nodes: [],
  };

  const tableSchema = {
    showActionColumn: true,
    columns: [
      { field: "id", headerName: "ID" },
      { field: "title", headerName: "Title" },
      { field: "description", headerName: "Description" },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu: [
          {
            name: "delete",
            label: "Delete data",
            icon: IconTrash,
            props: {
              color: "red",
            },
          },
        ],
      },
    ],
  };

  const formSchema = {
    title: "AI Workflow",
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
      size: "xl", //xs, sm, xl  ....100%
      position: "right",
    },
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "section-basic",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Workflow Info",
            description: "Please fill in the detail of the AI Prompt",
            withBorder: false,
            minHeight: "0px",
          },
        },
        {
          key: "section-tabs",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Workflow Diagram",
          },
          tab: [
            {
              key: "tab-workflow-diagram",
              label: "Workflow Diagram",
            },
            {
              key: "tab-credentials",
              label: "Credentials",
            },
            {
              key: "tab-workflow-tester",
              label: "Tester",
            },
          ],
        },
        {
          key: "section-workflow-diagram",
          parent: "tab-workflow-diagram",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Workflow",
            description: "Please fill in the detail of the AI Workflow",
          },
        },
        {
          //credentials
          key: "section-credentials",
          parent: "tab-credentials",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            description: "Please fill in the credentials for the workflow",
          },
        },
        {
          key: "section-workflow-tester",
          parent: "tab-workflow-tester",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Workflow Tester",
            description: "Test your workflow configuration",
          },
        },
      ],
      fields: [
        {
          name: "id",
          component: TextInput,
          parent: "section-basic",
          props: { required: true, label: "ID" },
        },
        {
          name: "title",
          component: TextInput,
          parent: "section-basic",
          props: { required: true, label: "Title" },
        },
        {
          name: "description",
          component: TextInput,
          parent: "section-basic",
          props: { label: "Description" },
        },
        {
          name: "nodes",
          component: WorkflowDiagram,
          parent: "section-workflow-diagram",
          props: {},
        },
        {
          component: WorkflowTester,
          parent: "section-workflow-tester",
          props: {},
        },
        {
          name: "credentials",
          component: WorkflowCredentials,
          parent: "section-credentials",
          props: {},
        },
      ],
    },
  };

  return (
    <>
      <PageList
        title="AI Workflow"
        apiEntity={apiEntity}
        initialValues={initialValues}
        tableSchema={tableSchema}
        formSchema={formSchema}
      />
    </>
  );
};

export default AIWorkflow;
